import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
import { useNavigate } from "react-router-dom";

const ReviewSlick = () => {
  const navigate = useNavigate();

  const moveBottom = () => {
    console.log("눌림");
    const pageHeight = document.documentElement.scrollHeight;

    window.scrollTo({
      top: pageHeight, // 페이지의 높이로 스크롤
      behavior: "smooth",
    });
  };
  const movePage = (path) => {
    navigate(path);
    window.location.reload();
  };
  return (
    <div className="review_slide_wrap animate__animated animate__fadeIn">
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
      <Swiper
        modules={[Navigation, Pagination, A11y, Autoplay]}
        slidesPerView={4}
        spaceBetween={"40px"}
        navigation={{
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        }}

        // autoplay={{ delay: 5000, disableOnInteraction: false }}
      >
        <SwiperSlide className="swiper_slide">
          <div className="review_block">
            <div className={`review_num`}>01</div>
            <div className="review_text_box">
              <div className="review_text title">
                키움성장클리닉 병원에서 추적관찰하고 싶은 믿음이 생겼습니다.
              </div>
              <div className="review_text bottom">
                다른 병원 방문 후 뼈나이가 너무 높게 나와서 방문하게 되었습니다.
                선생님께서 친절히 아이 뼈사진과 자료사진과 비교해봐주시면서
                자세히 설명 해주셔서 아이의 상태를 이해하는데 많은 도움이
                되었습니다. 너무 감사드리고.. 계속 키움성장클리닉 병원에서
                추적관찰하고 싶은 믿음이 생겼습니다.
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper_slide">
          <div className="review_block">
            <div className={`review_num`}>02</div>
            <div className="review_text_box">
              <div className="review_text title">
                원장선생님께서 알기쉽게 아이의 뼈나이와 성장속도를 설명해
                주셨어요.
              </div>
              <div className="review_text bottom">
                원장선생님께서 알기쉽게 아이의 뼈나이와 성장속도를 설명해
                주셨어요. 그리고 성장을 위해 필요한 것들을 설명해주셨습니다.
                사실 수면, 영향, 운동 다 아는 얘기지만 현실적으로 공부하는
                나이라 다 챙기기 쉽지않은 현실인데 이 시기에 꼭 챙겨야할 것들을
                다시한번 생각해봤네요. 자칫 성장클리닉은 공포감? 조성해서 걱정을
                배가 시킨다고 들었는데, 객관적인 설명을 들을수있어서 좋았습니다.
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper_slide">
          <div className="review_block">
            <div className={`review_num`}>03</div>
            <div className="review_text_box">
              <div className="review_text title">
                아이한테도 어떤 걸 먹으면 좋은지 얘기해 주셔서 너무 좋았어요
              </div>
              <div className="review_text bottom">
                오늘 예약한 시간 맞춰서 다녀왔는데 검사 비용은 다른 병원과
                차이는 나지 않았지만 설명을 상세히 해주셨고 이해가 잘 되도록
                해주셨어요 아이가 체중이 좀 있는 편이어서 걱정됐었는데 이것도 잘
                말씀해주셨고 아이한테도 어떤 걸 먹으면 좋은지 얘기해 주셔서 너무
                좋았어요 앞으로 팔로우업 하면서 다녀볼 생각이예요!
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper_slide">
          <div className="review_block">
            <div className={`review_num`}>04</div>
            <div className="review_text_box">
              <div className="review_text title">
                절대로 공포 유발하지 않으시고 아이 진심으로 걱정해주십니다!
              </div>
              <div className="review_text bottom">
                좋으신 선생님 항상 좋은말씀 많이 해주시고 절대로 공포 유발하지
                않으시고 아이 진심으로 걱정해주시고 뵐때마다 참 감사해요 그나마
                선생님 덕에 멘탈 붙들고 지냈던 거 같아요ㅠㅠ 3개월후에
                뵙겠습니다 진심이 전해지는 진료 늘 감사합니다
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper_slide">
          <div className="review_block">
            <div className={`review_num`}>05</div>
            <div className="review_text_box">
              <div className="review_text title">감사합니다</div>
              <div className="review_text bottom">
                원장님 너무좋으시고, 아이에게도 설명 친절히 잘해주셔서 아이가
                미션 받은 느낌으로 집에 돌아와선 밥이랑 잘 챙겨먹겠다고 하네요!
                감사합니다
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper_slide">
          <div className="review_block">
            <div className={`review_num`}>06</div>
            <div className="review_text_box">
              <div className="review_text title">
                말 한마디로도 큰 힘 주시는 선생님 항상 감사합니다
              </div>
              <div className="review_text bottom">
                초1 입학 직전이었으니 벌써 햇수로 4년째네요... 자식일인지라
                병원가기 전이면 늘 마음이 무겁고 신경이 많이 쓰이는데 원장님이
                항상 말씀을 정말 예쁘게 하셔서 병원 나올 때면 심적으로 치유받는
                느낌이에요 간호사분들도 모두 친절하세요 단순히 집에서 가까워서
                가는 병원 아니고 근처에 강남성모도 있지만 자동으로 여기로 올 수
                밖에 없답니다:) 여자 아이라 여 선생님이 더 편하기도 하지만
                단순히 그런 이유를 넘어서 정말로 아이의 성장을 위해 고민해주시고
                함부로 재단하지 않으시는 허 선생님이 계시기에 그래요 말
                한마디로도 큰 힘 주시는 선생님 항상 감사합니다
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper_slide">
          <div className="review_block">
            <div className={`review_num`}>07</div>
            <div className="review_text_box">
              <div className="review_text title">
                원장님이 너무 진정성 있게 진료를 봐주시네요
              </div>
              <div className="review_text bottom">
                원장님이 너무 진정성 있게 진료를 봐주시네요 저희 아이가 또래보다
                키가 좀 커서 걱정이 많이 되어가지구 엑스레이도 촬영하고 초음파도
                봤어요 뼈나이는 만나이와 비슷하다 하시구 가슴발달도 걱정할 정돈
                아니라하셔서 6개월뒤에 다시 체크하러 오라고 하셨어요 설명도
                알아듣기 쉽게 해주시고 아이한테도 거부감없이 대화하면서 잘
                먹으라고 해주셨어요 다녀오니 마음이 너무 편하네요 6개월뒤에도
                미리 예약하고 왔습니다ㅎㅎ 과잉진료도 없고 너무 잘 보고왔습니다
                감사해요~~
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default ReviewSlick;
